<template>
  <div id="player">
    <sk-player :shows-api="shows" :stream-api="api" :stream-url="feed" :country="country" />
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VuexStore from './store/store'
import SkPlayer from  './components/SkPlayer.vue'

Vue.use(Vuex)

const store = new Vuex.Store(VuexStore)

export default {
  name: 'Player',
  store,
  //Letop deze props komen uit de init in main.js
  props: [
    'shows',
    'api',
    'feed',
    'country'
  ],
  components: {
    SkPlayer,
  }
}
</script>

<style>
#player {
  
}
</style>
